<template>
    <div class="form-group case-comment">
        <label for="case-comment">{{ $t('comment') }}</label>
        <textarea id="case-comment" class="form-control" @blur="save" @input="(e) => setComment({id: value, comment: e.target.value})" :value="comment(value)"></textarea>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      comment: 'pcase/comment',
      caseById: 'pcase/byId'
    })
  },
  methods: {
    ...mapMutations({
      setComment: 'pcase/setComment',
      setError: 'alert/setError'
    }),
    async save () {
      try {
        const params = { comment: this.comment(this.value) }
        await this.axios.post(`/api/patient-cases/${this.value}/comment`, params)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.case-comment {
    textarea {
        height: 150px;
    }
}
</style>
<i18n>
{
  "ka": {
      "comment": "კომენტარი"
  },
  "en": {
      "comment": "Comment"
  }
}
</i18n>
